export default __webpack_public_path__ + "static/media/SENSIS_TRUE_LOCAL.51bb6846.png";